<template>
  <el-dialog
    :title="$tt(activeEventType.text)"
    :visible="isShowModal"
    width="70%"
    top="5vh"
    custom-class="dialogContent"
    append-to-body
    :close-on-click-modal="false"
    @close="switchModalVisible(false)"
    :destroy-on-close="true"
  >
    <div class="allDirectives">
      <div v-if="hasLeftSearchType.includes(activeEventType.key)">
        <el-form
            :inline="true"
            size="mini"
            :model="leftSearchForm"
            class="activeEventType-left-search"
        >
          <el-input
            v-for="item in (eventTypeColumnsConfig[activeEventType.key].data || eventTypeColumnsConfig[activeEventType.key].leftData)"
            :key="item.prop"
            v-model="leftSearchForm[item.prop]"
            :placeholder="$tt(item.label)"
          ></el-input>
          <el-button
              type="primary"
              class="searchBtn"
              @click="searchLeft"
              >{{ $tt("查询") }}</el-button
          >
        </el-form>
      </div>
      <el-table
        :data="leftFilterData"
        border
        style="width: 100%"
        @selection-change="
          (s) => {
            handleCheckedDChange(s, 1);
          }
        "
        >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          :prop="c.prop"
          :label="$tt(c.label)"
          v-for="c in leftTableColumns"
          :key="c.prop"
          :sortable="$listSortable(c)"
          :show-overflow-tooltip="$listOverflow(c)"
          :min-width="$listColMinWidth(c)"
        />
      </el-table>
    </div>
    <div class="switches">
      <div>
        <el-button
          type="primary"
          icon="el-icon-d-arrow-right"
          @click="addBindedData"
        />
      </div>
      <div>
        <el-button
          type="primary"
          icon="el-icon-d-arrow-left"
          @click="removeBindedData"
        />
      </div>
    </div>
    <div class="selectedDirectives">
      <el-alert
        class="statusTip"
        :closable="false"
        v-if="
          activeEventType.key == 'pressEvent' ||
          activeEventType.key == 'pressAgainEvent'
        "
        :title="$tt('0为按钮初始状态，1为按钮按压状态')"
        type="info"
      >
      </el-alert>
      <el-table
        :data="bindedData"
        border
        style="width: 100%"
        @selection-change="
          (s) => {
            handleCheckedDChange(s, 2);
          }
        "
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          :prop="c.prop"
          :label="$tt(c.label)"
          v-for="c in rightTableColumns"
          :key="c.prop"
          :sortable="c.prop !== 'status'"
          :show-overflow-tooltip="c.prop !== 'status'"
          :min-width="$listColMinWidth(c)"
        >
          <template slot-scope="scope">
            <el-select
              v-if="c.prop == 'status'"
              :value="scope.row.status"
              :placeholder="$tt('请选择')"
              @change="
                (v) => {
                  onStatusChange(v, scope.row);
                }
              "
            >
              <el-option
                v-for="item in statusesOptions"
                :key="item.value"
                :label="$tt(item.label)"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-else>
              {{ scope.row[c.prop] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShowModal = false">{{ $tt("取 消") }}</el-button>
      <el-button type="primary" @click="bindButtonEvents">{{ $tt("确 定") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/Modal";
import eventBus from "@/utils/eventBus";
import { parseCanvasAllData } from "@/utils/canvasPageLoader";
const commonColumn = [
  {
    prop: "buttonName",
    label: "按钮名称",
  },
  {
    prop: "alias",
    label: "按钮别名",
  },
];
export default {
  components: { Modal },
  props: {
    activeEventType: Object,
  },
  data() {
    return {
      leftSearchForm: {},
      hasLeftSearchType: ['mutuallyEvent', 'jumpEvent', 'pressEvent', 'pressAgainEvent'],
      isShowModal: false,
      leftFilterData: [],
      //左侧表格的数据
      leftTableData: [],
      //右侧表格数据
      bindedData: [],
      //左侧选择的数据
      checkedLeft: [],
      //右侧选择的数据
      checkedRight: [],
      //左侧表格的列
      leftTableColumns: [],
      //右侧表格的列
      rightTableColumns: [],

      eventTypeColumnsConfig: {
        mutuallyEvent: {
          data: commonColumn,
        },
        jumpEvent: {
          data: [
            {
              prop: "pageName",
              label: "页面名称",
            },
          ],
        },
        pressEvent: {
          notSame: true,
          leftData: commonColumn,
          rightData: [
            ...commonColumn,
            {
              prop: "status",
              label: "状态",
            },
          ],
        },
        pressAgainEvent: {
          notSame: true,
          leftData: commonColumn,
          rightData: [
            ...commonColumn,
            {
              prop: "status",
              label: "状态",
            },
          ],
        },
      },
      statusesOptions: [
        {
          value: "0",
          label: "初始状态",
        },
        {
          value: "1",
          label: "按压状态",
        },
      ],
    };
  },
  mounted() {
    //初始化表格的列
    this.initTableColumns();
    //初始化左侧表格的数据
    this.initLeftTableData();
    //初始化右侧表格的数据
    this.initBindedData();
  },
  watch: {
    activeEventType(v) {
      this.initLeftSearch(v);
      this.initTableColumns(v);
      this.initLeftTableData(v);
      this.initBindedData(v);
    },
    curComponent() {
      this.initTableColumns();
      this.initLeftTableData();
      this.initBindedData();
    },
  },
  computed: mapState(["curComponent", "componentData", "selectedCurrentPage", "canvasAllData"]),
  methods: {
    sameId(a, b) {
      return a != null && b != null && String(a) === String(b);
    },
    boundIds(raw) {
      const list = Array.isArray(raw) ? raw : [];
      return list
        .map((item) => (item && typeof item === "object" ? item.id : item))
        .filter((id) => id != null && id !== "");
    },
    findLeftRow(id) {
      return this.leftTableData.find((a) => this.sameId(a.id, id));
    },
    searchLeft() {
      this.leftFilterData = this.leftTableData.filter((a) => {
        let isRight = true;
        for (var key in this.leftSearchForm) {
          let val = this.leftSearchForm[key].trim();
          if (val !== '') {
            isRight = a[key] && String(a[key]).indexOf(val) !== -1;
          }
          if (!isRight) {
            isRight = false;
            break;
          }
        }
        return isRight;
      });
    },
    initLeftSearch(type) {
      if (!type) {
        return;
      }
      switch(type.key) {
        case 'jumpEvent':
          // 跳转事件
          this.leftSearchForm = {
            pageName: ''
          };
          break;
        case 'mutuallyEvent':
        case 'pressEvent':
        case 'pressAgainEvent':
          // 互斥事件
          // 联动事件
          this.leftSearchForm = {
            buttonName: '',
            alias: ''
          };
          break;
        default:
          break;
      }
    },
    switchModalVisible(bol) {
      this.isShowModal = bol;
      if (bol) {
        const pages = parseCanvasAllData(this.canvasAllData);
        const pageIds = Object.keys(pages || {});
        const runInit = () => {
          this.initTableColumns();
          this.initLeftTableData();
          this.initBindedData();
        };
        if (!pageIds.length) {
          this.$nextTick(runInit);
          return;
        }
        eventBus.$emit("ensureCanvasPages", { pageIds, done: () => this.$nextTick(runInit) });
      }
    },
    onStatusChange(v, row) {
      const i = this.bindedData.findIndex((i) => i.id == row.id);
      this.bindedData[i].status = v;
    },
    removeBindedData() {
      this.bindedData = _.differenceBy(
        this.bindedData,
        this.checkedRight,
        "id"
      );
    },
    addBindedData() {
      const { key } = this.activeEventType;
      const newA = _.cloneDeep(this.checkedLeft).reduce((re, item) => {
        re.push({
          id: item.id,
          buttonName: item.buttonName,
          alias: item.alias,
          status: "0",
        });
        return re;
      }, []);
      this.bindedData = _.uniqBy(
        [
          ...this.bindedData,
          ...(key == "pressEvent" || key == "pressAgainEvent"
            ? newA
            : this.checkedLeft),
        ],
        (row) => String(row.id)
      );
    },
    initTableColumns(v) {
      const { key } = v || this.activeEventType;
      if (!key || !this.eventTypeColumnsConfig[key]) {
        return;
      }
      if (this.eventTypeColumnsConfig[key].notSame) {
        this.leftTableColumns = this.eventTypeColumnsConfig[key].leftData;
        this.rightTableColumns = this.eventTypeColumnsConfig[key].rightData;
      } else {
        const data = this.eventTypeColumnsConfig[key].data;
        this.leftTableColumns = data;
        this.rightTableColumns = data;
      }
    },
    initLeftTableData(v) {
      const { key } = v || this.activeEventType;
      if (!key) {
        return;
      }
      if (key == "mutuallyEvent") {
        const pages = parseCanvasAllData(this.canvasAllData);
        pages[this.selectedCurrentPage] = _.cloneDeep(this.componentData);
        const btns = this.getOtherAllBtns(_.flattenDeep(Object.values(pages)), this.curComponent);
        var arr = btns.reduce((res, item) => {
          res.push({
            alias: item.style && item.style.alias,
            buttonName: item.propValue,
            id: item.id,
          });
          return res;
        }, []);
        this.leftFilterData = JSON.parse(JSON.stringify(arr));
        this.leftTableData = arr;
      } else if (key == "jumpEvent") {
        const pages = parseCanvasAllData(this.canvasAllData);
        const pageData = [];
        for (const pageKey in pages) {
          if (String(pageKey) === String(this.selectedCurrentPage)) {
            continue;
          }
          const pageArr = pages[pageKey];
          pageData.push({
            id: pageKey,
            pageName: pageArr && pageArr[0] && pageArr[0].style && pageArr[0].style.pageName,
          });
        }
        this.leftTableData = pageData;
        this.leftFilterData = JSON.parse(JSON.stringify(pageData));
      } else if (key == "pressEvent" || key == "pressAgainEvent") {
        const pages = parseCanvasAllData(this.canvasAllData);
        pages[this.selectedCurrentPage] = _.cloneDeep(this.componentData);
        const allBtns = this.getOtherAllBtns(_.flattenDeep(Object.values(pages)), this.curComponent);
        var pressArr = allBtns.reduce((res, item) => {
          res.push({
            alias: item.style && item.style.alias,
            buttonName: item.propValue,
            id: item.id,
          });
          return res;
        }, []);
        this.leftFilterData = JSON.parse(JSON.stringify(pressArr));
        this.leftTableData = pressArr;
      }
    },
    getOtherAllBtns(all, curComp) {
      const curId = curComp && curComp.id;
      const finalArr = [];
      const walk = (list) => {
        if (!Array.isArray(list)) {
          return;
        }
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (!item) {
            continue;
          }
          if (item.component == "v-button" && !this.sameId(item.id, curId)) {
            finalArr.push(item);
          }
          if (Array.isArray(item.propValue)) {
            walk(item.propValue);
          }
        }
      };
      walk(all);
      return finalArr;
    },
    initBindedData(v) {
      const { key } = v || this.activeEventType;
      if (!key || !this.curComponent || !this.curComponent.events) {
        this.bindedData = [];
        return;
      }
      const raw = this.curComponent.events[key] || [];
      if (key == "pressEvent" || key == "pressAgainEvent") {
        const list = Array.isArray(raw) ? raw : [];
        this.bindedData = list.map((item) => {
          const id = item && typeof item === "object" ? item.id : item;
          const left = this.findLeftRow(id);
          if (item && typeof item === "object") {
            return {
              ...(left || {}),
              ...item,
              id,
              buttonName: item.buttonName || (left && left.buttonName) || "",
              alias: item.alias || (left && left.alias) || "",
              status: item.status != null ? item.status : "0",
            };
          }
          return left
            ? { ...left, status: "0" }
            : { id, buttonName: String(id), alias: "", status: "0" };
        });
        return;
      }
      const ids = this.boundIds(raw);
      this.bindedData = ids.map((id) => {
        const left = this.findLeftRow(id);
        if (left) {
          return { ...left };
        }
        if (key === "jumpEvent") {
          return { id, pageName: String(id) };
        }
        return { id, buttonName: String(id), alias: "" };
      });
    },
    handleCheckedDChange(s, type) {
      //type 1:左侧 2：右侧
      if (type == 1) {
        this.checkedLeft = s;
      } else {
        this.checkedRight = s;
      }
    },
    bindButtonEvents() {
      const { key } = this.activeEventType;
      if (key === 'jumpEvent' && this.bindedData.length > 1) {
        // 跳转事件最多可配置一个页面
        this.$message.error('跳转事件最多可配置一个页面');
        return;
      }
      this.$store.commit("bindEvents", {
        type: this.activeEventType.key,
        data:
          key == "pressEvent" || key == "pressAgainEvent"
            ? this.bindedData
            : this.bindedData.map((item) => item.id),
      });
      this.switchModalVisible(false);
    },
  },
};
</script>

<style lang="scss">
.dialogContent {
  .el-dialog__body {
    display: flex !important;
  }
  .allDirectives {
    flex: 1;
    .activeEventType-left-search {
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 10px;
        margin-bottom: 10px;
        display: flex;
    }
  }
  .selectedDirectives {
    flex: 1;
    .statusTip {
      margin-bottom: 12px;
    }
  }
  .switches {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 200px;
    & div {
      margin-bottom: 12px;
    }
  }
}
</style>
